import React, { useState } from 'react';

type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> & {
  value: string | number;
  onValueChange: (value: string) => void;
};
export default function CurrencyInput({ value, onValueChange, onFocus, onBlur, readOnly, ...props }: Props) {
  const [focused, setFocused] = useState(false);
  const [draft, setDraft] = useState('');
  const formatted = value === '' ? '' : Number(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  return <input {...props} type="text" inputMode="decimal" readOnly={readOnly}
    placeholder={props.placeholder || '$0.00'} value={focused && !readOnly ? draft : formatted}
    onFocus={e => { setDraft(String(value)); setFocused(true); onFocus?.(e); }}
    onBlur={e => { setFocused(false); onBlur?.(e); }}
    onChange={e => {
      const next = e.target.value.replace(/[$,]/g, '');
      if (/^-?\d*(\.\d{0,2})?$/.test(next)) { setDraft(next); onValueChange(next); }
    }} />;
}
